
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { environment } from 'src/environments/environment';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { VideoLibraryService } from '../video-library.service';
import { Subscription } from 'rxjs';
import { CroppedImage } from 'src/app/core/image-cropper/image-cropper.model';
import { ImageInfoExt, ImageInfoRaw, ImageSize, InstructorRaw, VideoInfoExt } from '../video-library.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { EToastType, HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { ProductSettingsService } from '../../equipment-settings/setting/product-settings.service';
import { ProductSettings } from '../../equipment-settings/setting/setting.model';

@Component({
  selector: 'app-video-information',
  templateUrl: './video-information.component.html',
  styleUrls: ['./video-information.component.scss']
})
export class VideoInformationComponent implements OnInit, AfterViewInit {
  private selectedPreview: number;
  private tooltipMsg: string;
  private cloudBasePath: string;
  private imageloading = true;
  private videoInfo: VideoInfoExt;
  private sub = new Subscription();
  private editImageTitle: string;
  private isShowEditImageModal = false;
  private editImageForAvatar = false;
  private editImageFile: File;
  private readonly filetypes = [ ".png", ".jpg", ".jpeg"];
  private isMobile = false;
  private showActionBtns = false;
  private isEdit = false;
  private fileError: string;
  private baseTypes: any[] = [];
  private strapiID?: number;
  private difficultyLevels = [
    {value: 'beginner', transId: 'BEGINNER'},
    {value: 'intermediate', transId: 'INTERMEDIATE'},
    {value: 'advanced', transId: 'ADVANCED'}
  ];
  private languages = [
    {value: 'Arabic', display: 'Arabic'},
    {value: 'Basque', display: 'Basque'},
    {value: 'Catalan', display: 'Catalan'},
    {value: 'Chinese_Simplified', display: 'Chinese Simplified'},
    {value: 'Chinese_Traditional', display: 'Chinese Traditional'},
    {value: 'Dutch', display: 'Dutch'},
    {value: 'English_UK', display: 'English UK'},
    {value: 'English_US', display: 'English US'},
    {value: 'Finnish', display: 'Finnish'},
    {value: 'French', display: 'French'},
    {value: 'German', display: 'German'},
    {value: 'Hebrew', display: 'Hebrew'},
    {value: 'Hungarian', display: 'Hungarian'},
    {value: 'Italian', display: 'Italian'},
    {value: 'Japanese', display: 'Japanese'},
    {value: 'Korean', display: 'Korean'},
    {value: 'Polish', display: 'Polish'},
    {value: 'Portuguese', display: 'Portuguese'},
    {value: 'Russian', display: 'Russian'},
    {value: 'Spanish', display: 'Spanish'},
    {value: 'Turkish', display: 'Turkish'},
    {value: 'Welsh', display: 'Welsh'}
  ]
  
  imageCropperParams: any;
  instructorList = [] as any;
  productSettingItem: any;
  @ViewChild('tooltip', { static: false }) tooltip: NgbTooltip;
  constructor(
    private _facilityService: FacilityService,   
    private commonUtil: CommonUtil,
    private route: ActivatedRoute,
    private router: Router,
    private vdoLibraryService: VideoLibraryService,
    private facilityService: FacilityService,
    private _breadcrumbService: BreadcrumbService, 
    private _loader: HaloLoaderService,
    private toast: HaloToastService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private settingsService: ProductSettingsService,
  ) { 
    
  }

  async ngOnInit() {
    const facilityChanges = this._facilityService.selectedFacilitySource.subscribe((fac) => {
      this.router.navigate(["/videoLibrary"]);
    });
    this.sub.add(facilityChanges);
    this.cloudBasePath = environment.cloudBasePath;
    this.baseTypes = this.vdoLibraryService.baseTypes;
    const id = Number(this.route.snapshot.paramMap.get('id'));    
    this.isEdit = this.route.snapshot.paramMap.get('action') === 'edit';
    const breadcrumb = this._breadcrumbService.get();
    breadcrumb[breadcrumb.length - 1] = `${this.commonUtil.translateText(this.isEdit?'EDIT':'ADD')} ${this.commonUtil.translateText('VIDEO.INFORMATION')}`;
    this._breadcrumbService.set(breadcrumb);
    this._loader.startProcess();
    try {
      const info = await this.vdoLibraryService.getVideoInfo(id);
      if (!this.isEdit) {
        const facilityId = this._facilityService.selectedFacilityId();
        const facility =  this._facilityService.getFacilityById(facilityId);
        if (facility) {
          for (let i = 0; i < facility?.consoleEquipments.length; i++) {
            const originalData = await this.settingsService.getGeneralProductSettings([facilityId], facility?.consoleEquipments[i].consoleType) as ProductSettings;
            this.productSettingItem =  originalData.productSettingsList.find(item => item.inUse === true);
            if (this.productSettingItem) {
              break;
            }
          }
        }
      }
      if(!info) this.onCancel();
      else {
        this.strapiID = info.id;
        this.videoInfo = JSON.parse(JSON.stringify(info.attributes));
        this.videoInfo.facilityId = this.videoInfo.facilityId??this.facilityService.selectedFacilityId();
        this.loadInstructorList();
        this.videoInfo.unitSystem = this.productSettingItem ? this.productSettingItem.displayUnits == 1 ? 'Metric' : 'Imperial' : this.videoInfo.unitSystem??'Metric';
        this.videoInfo.feedFM = this.videoInfo.feedFM??false;
        this.videoInfo.language = this.videoInfo.language??'English_US';
        this.videoInfo.difficultyLevel = this.videoInfo.difficultyLevel??'beginner';
        this.videoInfo.baseType = this.videoInfo.baseType??'Treadmill';
        this.videoInfo.title = this.videoInfo.title??'';
        this.videoInfo.description = this.videoInfo.description??'';
        this.videoInfo.publishedToFacility = this.videoInfo.publishedToFacility??false;
        this.videoInfo.lastPublishedOn = this.videoInfo.lastPublishedOn??'';      
        this.videoInfo.authorName = this.videoInfo.authorName??this.commonUtil.rootScopeData.currentUser.displayName;
        this.videoInfo.authorID = this.videoInfo.authorID??this.commonUtil.rootScopeData.currentUser.userId.toString();
        this.videoInfo.muxIdFacIdUID = `${this.videoInfo.muxAsset?.data?.id}-${this.videoInfo.facilityId}`;    
        this.videoInfo.videoThumbnails = [{base64:'', isSelected: false, index: 'i0'}];
        if(this.videoInfo.muxAsset?.data?.attributes.playback_id && this.videoInfo.muxAsset?.data?.attributes.duration) {
          this.videoInfo.videoThumbnails.push({
            base64:`https://image.mux.com/${this.videoInfo.muxAsset.data?.attributes.playback_id}/thumbnail.png?width=500&height=295&fit_mode=smartcrop&time=${this.videoInfo.muxAsset?.data?.attributes.duration/4}`,
            isSelected: false,
            index: 'i1'
          });
          this.videoInfo.videoThumbnails.push({
            base64:`https://image.mux.com/${this.videoInfo.muxAsset.data?.attributes.playback_id}/thumbnail.png?width=500&height=295&fit_mode=smartcrop&time=${(this.videoInfo.muxAsset?.data?.attributes.duration/4)*2}`,
            isSelected: false,
            index: 'i2'
          });
          this.videoInfo.videoThumbnails.push({
            base64:`https://image.mux.com/${this.videoInfo.muxAsset.data?.attributes.playback_id}/thumbnail.png?width=500&height=295&fit_mode=smartcrop&time=${(this.videoInfo.muxAsset?.data?.attributes.duration/4)*3}`,
            isSelected: false,
            index: 'i3'
          });
        }
        const workoutThumbnail = this.vdoLibraryService.getAvailableImageFormat(this.videoInfo.workoutThumbnail, ImageSize.THUMBNAIL);
        if(workoutThumbnail && (this.videoInfo.workoutThumbnailIndex === 'i0' || this.videoInfo.workoutThumbnailIndex === null)) {
          this.videoInfo.videoThumbnails[0] = {base64: workoutThumbnail.url||'', isSelected: true, index: 'i0'};
        } else {
          let selectedThumbnail = this.videoInfo.videoThumbnails.find(t => t.index === this.videoInfo.workoutThumbnailIndex);
          if(!selectedThumbnail) selectedThumbnail = this.videoInfo.videoThumbnails[1];
          selectedThumbnail.isSelected = true;
        }
        this.videoInfo.avatar = this.vdoLibraryService.getAvailableImageFormat(this.videoInfo.instructor?.data?.attributes?.avatar, ImageSize.THUMBNAIL);
        if(!this.videoInfo.avatar) this.videoInfo.avatar = new ImageInfoExt();
        this.videoInfo.avatar.base64 = this.videoInfo.avatar.url||'';
      }
    } catch (error) {
      console.error('API failed.');
    }
    this._loader.endProcess();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.onPreviewChanged(1));
  }

  private onCancel() {
    this.commonUtil.navigatePage(['/videoLibrary']);
  }

  async addInstructor(name : string){
    const formData = new FormData();
    const payload = {
      name: name,
      facilities: [{
        facilityId: this.videoInfo.facilityId
      }]
    };
    if(this.videoInfo.avatar && !!this.videoInfo.avatar.base64){
      formData.append('files.avatar', await this.base64toBlob(this.videoInfo.avatar.base64), `${this.facilityService.selectedFacilityId()}_${this.videoInfo.muxAsset?.data?.id}_instructor.png`);
    } 
    formData.append('data', JSON.stringify(payload));
    const status = await this.vdoLibraryService.addInstructor(formData) as any;
    if(!this.instructorList) this.instructorList = [];
    this.instructorList.push({ "value": status.data?.id?.toString(), "text": status.data?.attributes?.name, "data": status.data});
    this.instructorList = this.instructorList.slice(); // recopy to detect change
    this.videoInfo.instructor = { data: status.data };
    this.videoInfo.avatar = this.vdoLibraryService.getAvailableImageFormat(this.videoInfo.instructor?.data?.attributes?.avatar, ImageSize.THUMBNAIL);
    if(!this.videoInfo.avatar) this.videoInfo.avatar = new ImageInfoExt();
    this.videoInfo.avatar.base64 = this.videoInfo.avatar.url||'';
  }

  async update(){
    this._amplitudeAnalytics.logEvent({elementName: 'Update', action: "Click"});
    if(this.videoInfo.avatar?.isChanged && this.videoInfo.avatar.base64) {
      const instructorAvatarFormData = new FormData(); 
      const payload = {
        name: this.videoInfo.instructor?.data?.attributes.name,
        facilities: this.videoInfo.instructor?.data?.attributes.facilities
      };
      instructorAvatarFormData.append('files.avatar', await this.base64toBlob(this.videoInfo.avatar.base64), `${this.facilityService.selectedFacilityId()}_${this.videoInfo.muxAsset?.data?.id}_instructor.png`);
      instructorAvatarFormData.append('data', JSON.stringify(payload));
      this.vdoLibraryService.updateInstructor(instructorAvatarFormData, Number(this.videoInfo.instructor?.data?.id));     
    }
    this.updateVideoInformation();   
  }

  private async updateVideoInformation() {
    const formData = new FormData();    
    const selectedThumbnail = this.videoInfo.videoThumbnails?.find(t => t.isSelected);
    // property order is required for strapi to accept the request
    const payload: any = {
      "title": this.videoInfo.title,
      "description": this.videoInfo.description,
      "language": this.videoInfo.language,
      "instructorName": this.videoInfo.instructor?.data?.attributes.name,
      "difficultyLevel": this.videoInfo.difficultyLevel,
      "baseType": this.videoInfo.baseType,
      "feedFM": this.videoInfo.feedFM,
      "publishedToFacility": this.videoInfo.publishedToFacility,
      "lastPublishedOn": !this.videoInfo.lastPublishedOn?null:this.videoInfo.lastPublishedOn,
      "facilityId": this.videoInfo.facilityId,
      "authorName": this.videoInfo.authorName,
      "authorID": this.videoInfo.authorID,
      "muxAsset": this.videoInfo.muxAsset?.data?.id,
      "muxIdFacIdUID": this.videoInfo.muxIdFacIdUID,
      "status": (this.videoInfo.status === 'Edited' || this.videoInfo.status === 'Published') ? 'Edited' : 'Unpublished',
      "instructor": this.videoInfo.instructor?.data?.id,
      "workoutThumbnailIndex": selectedThumbnail?.index,
    };
    if(this.videoInfo.baseType === 'Treadmill') {
      payload.unitSystem = this.videoInfo.unitSystem;
    }
    if(selectedThumbnail && (selectedThumbnail?.index !== this.videoInfo.workoutThumbnailIndex || selectedThumbnail.isChanged) && selectedThumbnail.base64) {
      formData.append('files.workoutThumbnail', await this.base64toBlob(selectedThumbnail.base64), `${this.facilityService.selectedFacilityId()}_${this.videoInfo.muxAsset?.data?.id}_workoutThumbnail.png`);
    } else delete payload.workoutThumbnailIndex;
    formData.append('data', JSON.stringify(payload));
    try {
      this._loader.startProcess();
      if(this.strapiID) await this.vdoLibraryService.editVideoInfo(formData, this.strapiID);
      else await this.vdoLibraryService.addVideoInfo(formData);
      this.showActionBtns = false;
      this.commonUtil.rootScopeData.isPageHasUnsavedChanges = false;
      const toastMsg = this.isEdit ? this.commonUtil.replaceValueAsHTMLOnTranslatedText('FACILITY.UPDATE.SUCCESS', [this.videoInfo.title||'']) : this.commonUtil.translateText('SUCCESS.ADD.VIDEO.DESCRIPTION');
      this._loader.endProcess();
      this.toast.creatToast(toastMsg, EToastType.SUCCESS);
      this.router.navigate(["/videoLibrary"]);
    } catch (error) {
      console.error('API error.');
      this._loader.endProcess();
      this.toast.creatToast(this.commonUtil.translateText('FAIL.ADD.VIDEO.DESCRIPTION'), EToastType.ERROR);
    }
  }

  private onEdit() {
    this.commonUtil.rootScopeData.isPageHasUnsavedChanges = true;
    this.showActionBtns = true;
  }

  private onPreviewChanged(index: number) {
    this.tooltip?.close();
    if(index == 1) this.tooltipMsg = this.commonUtil.translateText('WORKOUT.TITLE.TOOLTIP');
    else if(index == 2) this.tooltipMsg = this.commonUtil.translateText('WORKOUT.DESCRIPTION.TOOLTIP');
    else if(index == 3) this.tooltipMsg = this.commonUtil.translateText('WORKOUT.THUMBNAIL.TOOLTIP');
    else if(index == 4) this.tooltipMsg = this.commonUtil.translateText('INSTUCTOR.NAME.TOOLTIP');
    setTimeout(() => {
      this.selectedPreview = index; 
      this.tooltip?.open(); 
    });
  }

  onFeedFMChange(value: boolean) {
    this.videoInfo.feedFM = value;
    this.onEdit();
  }

  onWorkoutImageChange(thumbnail: ImageInfoExt) {
    if(thumbnail.isSelected) return;
    this.videoInfo.videoThumbnails?.forEach(v => v.isSelected = false);
    thumbnail.isSelected = true;
    this.fileError = '';
    this.onPreviewChanged(3);
    this.onEdit();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
  
  private async showEditImageModal(file: File, isAvatar: boolean) {
    if(file) {
      this.fileError = '';
      if(isAvatar) {
        this.fileError = await this.validateSelectedFile(file, 90, 90);
        this.imageCropperParams = {
          onlyScaleDown: true,
          resizeToWidth: 500,
          resizeToHeight: 295,
          cropperMinWidth: 90,
          cropperMinHeight: 90
        };
      } else {
        this.fileError = await this.validateSelectedFile(file, 500, 295);
        this.imageCropperParams = {
          maintainAspectRatio: true,
          resizeToWidth: 500,
          resizeToHeight: 295,
          cropperMinWidth: 0,
          cropperMinHeight: 0
        };
      }
      this.editImageForAvatar = isAvatar;
      if(!this.fileError) {
        this.editImageTitle = isAvatar ? this.commonUtil.translateText('INSTRUCTOR.AVATAR') : this.commonUtil.translateText('WORKOUT.THUMBNAIL');
        this.isShowEditImageModal = true;
        this.editImageFile = file;
      }
    }
    return false; // to make sure onchange is triggered if user choose the same file
  }

  private validateSelectedFile(file: File, minWidth: number, minHeight: number) : Promise<string> {
    return new Promise((resolve, reject) => {
      const extensions = /(\.png|\.jpg|\.jpeg)$/i;
      // Check format. png or jpeg && // Check fileSize. Max 5GB
      if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') ||
        !extensions.exec(file.name)) {
        resolve(this.commonUtil.translateText('FILE.UPLOAD.FORMAT'));
      } else{
        const reader = new FileReader();
        reader.onload = (event: any) => {
          const image = new Image();
          image.src = event.target.result;
          image.onload = () => {
            if (image.naturalHeight < minHeight || image.naturalWidth < minWidth) {
              resolve(this.commonUtil.translateText('IMAGE.DIMENSION.ERROR.MSG'));
            } else {
              resolve('');
            }
          };
          image.onerror = (ev) => {
            reject('Error loading file.');
          }
        };
        reader.readAsDataURL(file);
      }
    });
  }

  private async onCroppedImage(data: CroppedImage | null) {
    this.isShowEditImageModal = false;
    if(!data?.base64) return;    
    if(this.editImageForAvatar) {
      if(!this.videoInfo.avatar) this.videoInfo.avatar = new ImageInfoExt();
      this.videoInfo.avatar.base64 = data.base64;
      this.videoInfo.avatar.isChanged = true;
    } else if(this.videoInfo.videoThumbnails) { 
      this.videoInfo.videoThumbnails[0].base64 = data.base64;
      this.videoInfo.videoThumbnails[0].isChanged = true;
      this.onWorkoutImageChange(this.videoInfo.videoThumbnails[0]);
    }
    this.onEdit();
  }

  private async base64toBlob(data: string){
    const res = await fetch(data);
    return res.blob();
  }


  async loadInstructorList(){
     const list = await this.vdoLibraryService.getInstructorList(Number(this.videoInfo.facilityId)) as any;
     this.instructorList = list?.data?.map((val: InstructorRaw) => { return{ "value": val.id?.toString(), "text": val.attributes.name, "data": val}});
  }

  instructorDropdownChanged(selected: any) {
    if(!selected || this.videoInfo.instructor?.data?.id === selected.data?.id) return;
    this.videoInfo.instructor = { data: selected.data };
    this.videoInfo.avatar = this.vdoLibraryService.getAvailableImageFormat(this.videoInfo.instructor?.data?.attributes?.avatar, ImageSize.THUMBNAIL);
    if(!this.videoInfo.avatar) this.videoInfo.avatar = new ImageInfoExt();
    this.videoInfo.avatar.base64 = this.videoInfo.avatar.url||'';
  }
}
